// You can write more code here

/* START OF COMPILED CODE */

import TransitionEffectCover from "../prefabs/game/TransitionEffectCover";
/* START-USER-IMPORTS */
import { SceneData, SceneId, TransitionSceneData } from '../app-routing';
import { TransitionType } from '@scarybeasties/phaser-framework-core/enums';
import { TransitionScene } from '@scarybeasties/phaser-framework-core/scenes';
/* END-USER-IMPORTS */

export default class TransitionLoadScene extends TransitionScene {

  

  constructor() {
    super("TransitionLoadScene");

    /* START-USER-CTR-CODE */
    this.transitionType = TransitionType.SceneCoverScene;
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {

    // transitionPrefab
    const transitionPrefab = new TransitionEffectCover(this, 960, 384);
    this.add.existing(transitionPrefab);

    this.transitionPrefab = transitionPrefab;

    this.events.emit("scene-awake");
  }

  private transitionPrefab!: TransitionEffectCover;

  /* START-USER-CODE */

  private sceneData!: SceneData;
  private transitionSceneData!: TransitionSceneData;

  init(data: SceneData) {
    super.init(data);

    let transitionDefaults: TransitionSceneData = {
      sourceScene: this.scene.key,
      nextScene: SceneId.Title
    };

    this.transitionSceneData = Object.assign({}, transitionDefaults, data.transitionData);
    this.sceneData = data;
    // this.sceneData.transitionData = undefined;

    // this.scene.bringToTop(this);
  }

  create() {
    super.create();
    this.editorCreate();

    this.beginSceneCoverTransition(this.transitionSceneData, this.transitionPrefab);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
